import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { LinkTabNavHorizontal } from '../../components';

import css from './AdminNav.module.css';

/**
 * The admin pages' counterpart to UserNav: one tab per admin page, so Guro can
 * move between them without going through the profile menu. Same tabs and
 * placement as UserNav (below the topbar, desktop only; the phone menu carries
 * the admin links), on a tinted band so an admin page is recognisable as one.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {string} props.currentPage - 'AdminOverviewPage' | 'ListingAdminPage' | 'BannerAdminPage'
 * @returns {JSX.Element}
 */
const AdminNav = props => {
  const { className, rootClassName, currentPage } = props;
  const intl = useIntl();
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: <FormattedMessage id="AdminNav.overview" />,
      selected: currentPage === 'AdminOverviewPage',
      linkProps: { name: 'AdminOverviewPage' },
    },
    {
      text: <FormattedMessage id="AdminNav.listings" />,
      selected: currentPage === 'ListingAdminPage',
      linkProps: { name: 'ListingAdminPage' },
    },
    {
      text: <FormattedMessage id="AdminNav.banners" />,
      selected: currentPage === 'BannerAdminPage',
      linkProps: { name: 'BannerAdminPage' },
    },
  ];

  return (
    <LinkTabNavHorizontal
      className={classes}
      tabRootClassName={css.tab}
      tabs={tabs}
      skin="dark"
      ariaLabel={intl.formatMessage({ id: 'AdminNav.screenreader.adminNav' })}
    />
  );
};

export default AdminNav;
